/* global ajax_object */

export function initAjaxFiltersAndPagination() {
	const form = document.getElementById('ajax-filters');
	const section = document.querySelector('.last-posts__content');
	const container = document.getElementById('ajax-posts');
	const button = document.getElementById('load-more');

	if (!form || !section || !container || !button) return;

	let currentPage = 1;
	let activeTerms = [];

	const fetchPosts = (page = 1, append = false) => {
		const formData = new FormData();
		formData.append('action', 'load_more_posts');
		formData.append('nonce', ajax_object.nonce);
		formData.append('page', page);
		formData.append('post_type', section.dataset.postType);
		formData.append('posts_per_page', section.dataset.postsPerPage);
		formData.append('template', section.dataset.template);
		formData.append('taxonomy', section.dataset.taxonomy);
		formData.append('terms', JSON.stringify(activeTerms));

		const loader = document.getElementById('ajax-loader');
		if (loader) loader.hidden = false;

		fetch(ajax_object.ajax_url, {
			method: 'POST',
			body: formData,
		})
			.then(res => res.text())
			.then(html => {
				const isEmpty = !html.trim();

				if (append) {
					container.insertAdjacentHTML('beforeend', html);
				} else {
					container.innerHTML = html;
				}

				if (isEmpty) {
					button.style.display = 'none';
					button.disabled = true;
				} else {
					button.style.display = 'block';
					button.disabled = false;
				}

				// ✅ Cacher le loader après injection
				if (loader) loader.hidden = true;
			});
	};

	form.addEventListener('change', () => {
		const selected = form.querySelector('input[name="term"]:checked');
		activeTerms = [];

		if (selected && selected.value && selected.dataset.taxonomy) {
			activeTerms.push({
				taxonomy: selected.dataset.taxonomy,
				terms: [selected.value],
			});
		}

		currentPage = 1;
		button.dataset.page = 1;
		button.style.display = 'block';
		button.disabled = false;
		container.innerHTML = '';
		fetchPosts(currentPage, true);
	});



	button.addEventListener('click', () => {
		currentPage++;
		fetchPosts(currentPage, true);
		button.dataset.page = currentPage;
	});

	// Initial fetch if needed
	fetchPosts(currentPage, false);
}

document.addEventListener('DOMContentLoaded', () => {
	initAjaxFiltersAndPagination();
});